export default __webpack_public_path__ + "b7073e3ad52e289ae5c01cd523610bc9.png";